import React, { useState } from 'react'
import { FormGroup, Label, Input, Row, Col } from 'reactstrap';


const CompanyImageInput = (props) => {
    const { label, setImageInfo, setAlert } = props;
    const [imagePreview, setImagePreview] = useState('');

    const onUploadFile = (event) => {
        const file = event.target.files[0];
        if (file != null) {
            if (file.size > 64000) {
                setAlert({
                    message: 'La imagen debe pesar máximo 64Kb.',
                    color: 'danger'
                });
            } else {
                getBase64(file).then(data => {
                    setImageInfo({
                        data: data.replace(/^data:(.*,)?/, ''),
                        extension: file.type.split('/')[1]
                    });
                    setImagePreview(data);
                    setAlert({});
                },
                    () => setAlert({
                        message: 'Error al leer la imagen.',
                        color: 'danger'
                    }));
            }
        }
    }

    return (
        <FormGroup>
            <Label for="logo">{label}</Label>
            <Row>
                <Col sm={8}>
                    <Input
                        type="file"
                        name="logo"
                        id="logo"
                        accept="image/*"
                        onChange={onUploadFile} />
                </Col>
                {imagePreview !== '' ?
                    <Col>
                        <img
                            alt="Logo preview"
                            src={imagePreview}
                            width="64"
                            style={{ paddingBottom: "10px" }} />
                    </Col> : null
                }
            </Row>
        </FormGroup>
    );
}

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default CompanyImageInput;